import styled from 'styled-components';

export const Share = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const Download = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const VersionText = styled.div`
	margin-left: 8px;
	margin-right: 8px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const VersionDropdown = styled.div`
	margin-left: 8px;
	margin-right: 8px;
	padding: 4px 8px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	display: flex;
	align-items: center;
	gap: 6px;
	background: transparent;
	user-select: none;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const StatusIndicator = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	a {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: default;
		pointer-events: auto;
		width: 14px;
		height: 14px;
	}
`;
